import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
} from '@chakra-ui/react'
import { DrawerProps } from '../../utils/types/props.drawer'

import React from 'react'

const AppDrawer = ({ title, children, onClose, size, placement }: DrawerProps) => {
  return (
    <Drawer placement={placement} onClose={onClose} isOpen size={size}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>{title}</DrawerHeader>
          <DrawerBody>
           {children}
          </DrawerBody>
        </DrawerContent>
      </Drawer>
  )
}

export default AppDrawer
